import * as connectionStatusService from 'services/connection-status-service';
import * as logger from 'logger';
import { compareScanDatetime } from 'helpers/date-helper';
import { getDatabase } from 'database';
import { handleError, removeLongPendingItems } from '../helpers/data-sync-error-helpers';
import { handleNmvsResponse, performApiCall } from '../helpers/data-sync-api-helpers';
import { LogLevel } from 'types/log-level';
import { OperationItem } from 'types/operation-item';
import { updateItemProcessing } from 'services/item-service';
import { store } from 'pages/app/store';
import { UpdateOperationItemAction } from 'components/operation-grid/actions';

export async function syncData(): Promise<void> {
  const isOnline = await connectionStatusService.getStatus();
  if (isOnline) {
    await syncPendingItems();
  }
}

async function syncPendingItems() {
  const db = await getDatabase();
  let list: OperationItem[] = await db.readAll(db.config.indexes.Pending);

  if (list.length > 4) {
    logger.log(LogLevel.INFO, `Pending item count is ${list.length}`, 'dataSync.syncPendingItems', 'Pending Item Count');
  }

  const validOperationItems = await removeLongPendingItems(list);
  
  for (const item of validOperationItems.sort(compareScanDatetime)) {

    const key = item.clientTransactionId.toString();
    // ignore if item is already processing
    if (!item.isProcessing) {

      await updateItemProcessing(key, item, true);
      try {
        
        var response = await performApiCall(key, item);
        await handleNmvsResponse(key, item, response);
      }
      catch (error) {
        await handleError(key, item);
        logger.error(error, 'service-worker.handleError');
      }
      store.dispatch(new UpdateOperationItemAction(item.clientTransactionId));
    }
  }
}



// WEBPACK FOOTER //
// ./src/service-worker/data-syncs/data-sync.ts